import { Instagram, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-black text-white px-6 md:px-12 pt-24 md:pt-32 pb-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <img
              src="/assets/logo-white.png"
              alt="Manzano Real Estate"
              data-testid="footer-logo"
              className="h-20 md:h-24 w-auto object-contain"
            />
            <p className="mt-6 max-w-md text-white/60 leading-relaxed text-sm">
              California's most discerning real estate brokerage. By appointment, by
              referral, by reputation.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5 text-[#c0c0c0]">Visit</p>
            <p className="text-sm text-white/70 leading-relaxed">
              27600 Bouquet Canyon Rd.
              <br />
              Santa Clarita, CA 91350
              <br />
              <br />
              (661) 212-1300
              <br />
              alfredo@manzano.homes
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5 text-[#c0c0c0]">Connect</p>
            <div className="flex gap-5">
              <a
                href="https://www.instagram.com/manzanohomes/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.youtube.com/@CoachManzanoRealEstate"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                data-testid="footer-youtube"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="silver-rule opacity-30" />

        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-[10px] tracking-[0.3em] uppercase text-white/40">
          <p>© {new Date().getFullYear()} Manzano Real Estate · DRE# 02000000</p>
          <div className="flex gap-8">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Fair Housing</a>
          </div>
        </div>

        <div className="pt-6 text-center">
          <a
            href="https://theaidept.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ai-dept-badge"
            className="group inline-block text-[11px] tracking-wide text-white/30 hover:text-white/70 transition-opacity duration-300 animate-in fade-in"
          >
            Built with{" "}
            <span className="font-semibold text-white/50 group-hover:text-white/90 group-hover:underline underline-offset-[3px] transition-all duration-300">
              The AI Dept.
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
